export default __webpack_public_path__ + "static/media/functional-fundamental-icon.51bac386.svg";